import React, { useState, useEffect } from "react";
import { apiFetch } from "../utils/api";

const COLORES_HILO = ["#2563EB","#F97316","#16A34A","#92400E","#6B7280","#F9FAFB","#DC2626","#111827","#CA8A04","#7C3AED","#DB2777","#0891B2"];
const NOMBRES_HILO = ["Azul","Naranja","Verde","Marron","Gris","Blanco","Rojo","Negro","Amarillo","Violeta","Rosado","Aqua"];
const NOMBRES_BUFFER = ["Azul","Naranja","Verde","Marron","Gris","Blanco","Rojo","Negro","Amarillo","Violeta","Rosado","Aqua"];

const S = {
  overlay:{position:"fixed",inset:0,background:"rgba(0,0,0,0.92)",zIndex:400,display:"flex",flexDirection:"column",fontFamily:"Roboto,sans-serif"},
  header:{background:"#0D4F7C",padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0},
  body:{flex:1,overflowY:"auto",padding:"12px"},
  card:{background:"#1a1a2e",border:"1px solid #2a2a4a",borderRadius:10,padding:"12px",marginBottom:10},
  cardTitle:{fontSize:11,color:"#90CAF9",fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em",marginBottom:8},
  row:{display:"flex",alignItems:"center",gap:8,marginBottom:6},
  label:{fontSize:12,color:"#9CA3AF",minWidth:110},
  val:{fontSize:13,color:"#F9FAFB",fontWeight:500},
  valOk:{fontSize:13,color:"#34D399",fontWeight:600},
  valWarn:{fontSize:13,color:"#FBBF24",fontWeight:600},
  valErr:{fontSize:13,color:"#F87171",fontWeight:600},
  divider:{height:1,background:"#2a2a4a",margin:"8px 0"},
  btnClose:{background:"rgba(255,255,255,0.15)",border:"none",color:"#fff",borderRadius:8,padding:"6px 14px",fontSize:13,cursor:"pointer"},
  btnSave:{background:"#1E7BBF",border:"none",color:"#fff",borderRadius:8,padding:"6px 14px",fontSize:13,cursor:"pointer",fontWeight:600},
  portGrid:{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6,marginTop:8},
  portBox:{display:"flex",flexDirection:"column",alignItems:"center",padding:"8px 4px",borderRadius:8,border:"1px solid #2a2a4a",cursor:"pointer"},
  portNum:{fontSize:10,color:"#6B7280",marginBottom:4},
  portCircle:{width:32,height:32,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:600},
  portName:{fontSize:9,color:"#9CA3AF",marginTop:3,textAlign:"center",maxWidth:54,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"},
  tab:{padding:"6px 14px",borderRadius:20,fontSize:12,fontWeight:500,cursor:"pointer",border:"none"},
  textarea:{width:"100%",padding:"8px 10px",borderRadius:8,border:"1px solid #2a2a4a",fontSize:12,background:"#0f0f1a",color:"#F9FAFB",resize:"vertical",minHeight:60,fontFamily:"Roboto,sans-serif",boxSizing:"border-box"},
  hiloLinea:{height:3,flex:1,borderRadius:2},
  hiloDot:{width:10,height:10,borderRadius:"50%",flexShrink:0},
};

function TabBtn({active, onClick, children}) {
  return <button onClick={onClick} style={{...S.tab,background:active?"#1E7BBF":"rgba(255,255,255,0.08)",color:active?"#fff":"#9CA3AF"}}>{children}</button>;
}

function PotenciaVal({val}) {
  if(val===null||val===undefined) return <span style={S.val}>—</span>;
  const n = parseFloat(val);
  if(n>=-27&&n<=-8) return <span style={S.valOk}>{val} dBm ✓</span>;
  if(n<-27) return <span style={S.valErr}>{val} dBm ✗ muy baja</span>;
  return <span style={S.valWarn}>{val} dBm ⚠ alta</span>;
}

export default function NapDiagram({nap, equipos, onClose, user}) {
  const [data,setData]       = useState(null);
  const [loading,setLoading] = useState(true);
  const [error,setError]     = useState(null);
  const [tab,setTab]         = useState("puertos");
  const [notas,setNotas]     = useState("");
  const [saving,setSaving]   = useState(false);
  const [selPuerto,setSelPuerto] = useState(null);

  useEffect(()=>{
    apiFetch("/nap_diagram.php?nap_id="+nap.id).then(d=>{
      if(d.success){ setData(d); setNotas(d.nap.notas||""); }
      else setError(d.error||"Error al cargar");
      setLoading(false);
    }).catch(()=>{ setError("Error de conexion"); setLoading(false); });
  },[nap.id]);

  const saveNotas = async()=>{
    setSaving(true);
    await apiFetch("/equipos.php?tipo=nap",{method:"PUT",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:nap.id,nombre:nap.nombre,tipo_instalacion:nap.tipo_instalacion,puertos:nap.puertos,tipo_splitter:nap.tipo_splitter,mufa_id:nap.mufa_id,olt_id:nap.olt_id,estado:nap.estado,notas})});
    setSaving(false);
  };

  const getPortCliente = (p) => data ? data.clientes.find(x=>parseInt(x.puerto)===p)||null : null;

  const getPortBg = (p) => {
    const c = getPortCliente(p);
    if(!c) return "#064E3B";
    if(c.estado==="activo") return "#1E3A8A";
    if(c.estado==="suspendido") return "#78350F";
    return "#1F2937";
  };

  const getPortLabel = (p) => {
    const c = getPortCliente(p);
    if(!c) return "L";
    return c.nombre.split(" ")[0].substring(0,3).toUpperCase();
  };

  const totalPuertos = parseInt(nap.puertos)||8;
  const ocupados     = data ? data.clientes.filter(c=>c.estado==="activo").length : 0;
  const tipo_hilos   = data?.fibra ? parseInt(data.fibra.tipo_hilos) : 12;
  const buffers      = Math.ceil(tipo_hilos/12);

  return (
    <div style={S.overlay}>
      <div style={S.header}>
        <div>
          <p style={{margin:0,color:"#fff",fontWeight:600,fontSize:15}}>{nap.nombre}</p>
          <p style={{margin:0,color:"#90CAF9",fontSize:11}}>{nap.tipo_splitter} · {ocupados}/{totalPuertos} puertos · {nap.tipo_instalacion}</p>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={saveNotas} disabled={saving} style={S.btnSave}>{saving?"Guardando...":"Guardar notas"}</button>
          <button onClick={onClose} style={S.btnClose}>Cerrar</button>
        </div>
      </div>

      {loading && <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center"}}><p style={{color:"#90CAF9"}}>Cargando diagrama...</p></div>}
      {error   && <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center"}}><p style={{color:"#F87171"}}>{error}</p></div>}

      {!loading&&!error&&data&&(
        <div style={S.body}>
          <div style={{display:"flex",gap:6,marginBottom:12,overflowX:"auto"}}>
            <TabBtn active={tab==="puertos"}   onClick={()=>setTab("puertos")}>Puertos</TabBtn>
            <TabBtn active={tab==="recorrido"} onClick={()=>setTab("recorrido")}>Recorrido</TabBtn>
            <TabBtn active={tab==="fibra"}     onClick={()=>setTab("fibra")}>Fibra</TabBtn>
            <TabBtn active={tab==="optico"}    onClick={()=>setTab("optico")}>Optico</TabBtn>
            <TabBtn active={tab==="notas"}     onClick={()=>setTab("notas")}>Notas</TabBtn>
          </div>

          {tab==="puertos"&&<>
            <div style={S.card}>
              <div style={S.cardTitle}>Splitter {nap.tipo_splitter} — {ocupados}/{totalPuertos} puertos ocupados</div>
              <div style={S.portGrid}>
                {Array.from({length:totalPuertos},(_,i)=>i+1).map(p=>(
                  <div key={p} style={{...S.portBox,background:getPortBg(p),borderColor:selPuerto===p?"#60A5FA":"#2a2a4a"}} onClick={()=>setSelPuerto(selPuerto===p?null:p)}>
                    <div style={S.portNum}>{p}</div>
                    <div style={{...S.portCircle,background:getPortBg(p),color:"#fff",border:"1px solid rgba(255,255,255,0.2)"}}>{getPortLabel(p)}</div>
                    <div style={S.portName}>{getPortCliente(p)?getPortCliente(p).nombre.split(" ")[0]:"libre"}</div>
                  </div>
                ))}
              </div>
              <div style={{display:"flex",gap:12,marginTop:10,flexWrap:"wrap"}}>
                {[["#064E3B","Libre"],["#1E3A8A","Activo"],["#78350F","Suspendido"],["#1F2937","Inactivo"]].map(([bg,l])=>(
                  <div key={l} style={{display:"flex",alignItems:"center",gap:4}}>
                    <div style={{width:10,height:10,borderRadius:"50%",background:bg}}/>
                    <span style={{fontSize:11,color:"#9CA3AF"}}>{l}</span>
                  </div>
                ))}
              </div>
            </div>
            {selPuerto&&(()=>{
              const c = getPortCliente(selPuerto);
              return (
                <div style={S.card}>
                  <div style={S.cardTitle}>Puerto {selPuerto}</div>
                  {c?<>
                    <div style={S.row}><span style={S.label}>Cliente</span><span style={S.val}>{c.nombre}</span></div>
                    <div style={S.row}><span style={S.label}>Estado</span><span style={{...S.val,color:c.estado==="activo"?"#34D399":"#FBBF24"}}>{c.estado}</span></div>
                    <div style={S.row}><span style={S.label}>Telefono</span><span style={S.val}>{c.telefono||"—"}</span></div>
                    <div style={S.row}><span style={S.label}>Potencia medida</span><PotenciaVal val={c.potencia_dbm}/></div>
                  </>:<p style={{color:"#6B7280",fontSize:12,margin:0}}>Puerto libre — disponible para asignar cliente</p>}
                </div>
              );
            })()}
          </>}

          {tab==="recorrido"&&<>
            <div style={S.card}>
              <div style={S.cardTitle}>Trazabilidad hacia atras</div>
              {data.recorrido.length>0?(
                <div style={{display:"flex",flexDirection:"column",gap:0}}>
                  {data.recorrido.map((eq,i)=>(
                    <div key={i}>
                      <div style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0"}}>
                        <div style={{width:32,height:32,borderRadius:"50%",background:eq.tipo==="olt"?"#1E3A8A":eq.tipo==="mufa"?"#4C1D95":eq.tipo==="nap"?"#064E3B":"#78350F",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:"#fff",fontWeight:700,flexShrink:0}}>
                          {eq.tipo==="olt"?"OLT":eq.tipo==="mufa"?"MUF":eq.tipo==="nap"?"NAP":"POS"}
                        </div>
                        <div style={{flex:1}}>
                          <p style={{margin:0,fontSize:13,color:"#F9FAFB",fontWeight:500}}>{eq.nombre}</p>
                          <p style={{margin:0,fontSize:11,color:"#6B7280"}}>{eq.tipo.toUpperCase()}{eq.tipo==="nap"&&eq.id===nap.id?" — Esta NAP":""}</p>
                        </div>
                        {eq.tipo==="nap"&&parseInt(eq.id)===parseInt(nap.id)&&<span style={{fontSize:10,padding:"2px 8px",borderRadius:99,background:"#064E3B",color:"#34D399"}}>actual</span>}
                      </div>
                      {i<data.recorrido.length-1&&<div style={{width:2,height:16,background:"#2a2a4a",marginLeft:15}}/>}
                    </div>
                  ))}
                </div>
              ):<p style={{color:"#6B7280",fontSize:12,margin:0}}>No se detecto recorrido. Verifica que la fibra este trazada en el mapa pasando por esta NAP.</p>}
            </div>
            {data.fibra&&(
              <div style={S.card}>
                <div style={S.cardTitle}>Fibra de entrada</div>
                <div style={S.row}><span style={S.label}>Nombre</span><span style={S.val}>{data.fibra.nombre}</span></div>
                <div style={S.row}><span style={S.label}>Hilos</span><span style={S.val}>{data.fibra.tipo_hilos} hilos</span></div>
                <div style={S.row}><span style={S.label}>Instalacion</span><span style={S.val}>{data.fibra.tipo_instalacion}</span></div>
              </div>
            )}
          </>}

          {tab==="fibra"&&<>
            <div style={S.card}>
              <div style={S.cardTitle}>Estructura — {tipo_hilos} hilos / {buffers} {buffers===1?"buffer":"buffers"}</div>
              {data.nap_entrada?(
                <div style={{marginBottom:8,padding:"6px 10px",background:"rgba(30,123,191,0.15)",borderRadius:6,border:"1px solid rgba(30,123,191,0.3)"}}>
                  <p style={{margin:0,fontSize:12,color:"#60A5FA"}}>Hilo configurado: Buffer {data.nap_entrada.buffer_numero} ({NOMBRES_BUFFER[(data.nap_entrada.buffer_numero-1)%12]}) — Hilo {data.nap_entrada.hilo_numero} ({NOMBRES_HILO[(data.nap_entrada.hilo_numero-1)%12]})</p>
                </div>
              ):(
                <p style={{fontSize:11,color:"#FBBF24",marginBottom:8}}>⚠ Hilo de entrada no configurado</p>
              )}
              {Array.from({length:buffers},(_,b)=>(
                <div key={b} style={{marginBottom:12}}>
                  <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                    <div style={{width:12,height:12,borderRadius:"50%",background:COLORES_HILO[b%12]}}/>
                    <span style={{fontSize:12,color:"#D1D5DB",fontWeight:500}}>Buffer {b+1} — {NOMBRES_BUFFER[b%12]}</span>
                    {data.nap_entrada&&data.nap_entrada.buffer_numero===b+1&&<span style={{fontSize:10,color:"#60A5FA"}}>(desangrado)</span>}
                  </div>
                  {Array.from({length:Math.min(12,tipo_hilos-b*12)},(_,h)=>{
                    const esUsado = data.nap_entrada&&data.nap_entrada.buffer_numero===b+1&&data.nap_entrada.hilo_numero===h+1;
                    const bufDesangrado = data.nap_entrada&&data.nap_entrada.buffer_numero===b+1;
                    return (
                      <div key={h} style={{display:"flex",alignItems:"center",gap:6,marginBottom:4,paddingLeft:18,opacity:(!bufDesangrado&&b>0)?0.35:1}}>
                        <div style={{...S.hiloDot,background:COLORES_HILO[h%12],opacity:esUsado?1:0.5}}/>
                        <div style={{...S.hiloLinea,background:COLORES_HILO[h%12],opacity:esUsado?1:0.3}}/>
                        {esUsado?(
                          <div style={{width:14,height:14,borderRadius:"50%",background:"#F59E0B",border:"2px solid #D97706",display:"flex",alignItems:"center",justifyContent:"center",fontSize:8,color:"#fff",fontWeight:700}}>F</div>
                        ):(
                          <div style={{width:14,height:14,borderRadius:"50%",background:"rgba(255,255,255,0.08)",border:"1px solid #374151"}}/>
                        )}
                        <div style={{...S.hiloLinea,background:COLORES_HILO[h%12],opacity:esUsado?0:0.3}}/>
                        <span style={{fontSize:10,color:esUsado?"#FBBF24":"#4B5563",minWidth:80}}>{esUsado?"→ Splitter "+nap.tipo_splitter:"Hilo "+(h+1)+" "+NOMBRES_HILO[h%12]}</span>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Splitter interno</div>
              <div style={{display:"flex",alignItems:"center",gap:12}}>
                <div style={{padding:"10px 16px",background:"rgba(30,123,191,0.2)",border:"1px solid rgba(30,123,191,0.4)",borderRadius:8,textAlign:"center"}}>
                  <p style={{margin:0,fontSize:16,fontWeight:700,color:"#60A5FA"}}>{nap.tipo_splitter}</p>
                  <p style={{margin:0,fontSize:10,color:"#6B7280"}}>splitter</p>
                </div>
                <div style={{flex:1}}>
                  <p style={{margin:"0 0 4px",fontSize:12,color:"#9CA3AF"}}>Entradas: 1</p>
                  <p style={{margin:"0 0 4px",fontSize:12,color:"#9CA3AF"}}>Salidas: {totalPuertos}</p>
                  <p style={{margin:0,fontSize:12,color:"#9CA3AF"}}>Ocupados: {ocupados}/{totalPuertos}</p>
                </div>
              </div>
            </div>
          </>}

          {tab==="optico"&&<>
            <div style={S.card}>
              <div style={S.cardTitle}>Presupuesto optico calculado</div>
              {data.presupuesto.length>0?data.presupuesto.map((p,i)=>(
                <div key={i}>
                  <div style={S.row}>
                    <span style={S.label}>{p.concepto}</span>
                    <span style={p.tipo==="ok"?S.valOk:p.tipo==="warn"?S.valWarn:p.tipo==="perdida"?S.valWarn:p.tipo==="origen"?S.valOk:S.val}>{p.valor}</span>
                  </div>
                  {(p.tipo==="ok"||p.tipo==="warn")&&<div style={S.divider}/>}
                </div>
              )):<p style={{color:"#6B7280",fontSize:12,margin:0}}>Sin datos. Verifica que la fibra este configurada y la OLT tenga potencia registrada.</p>}
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Potencia medida en campo por puerto</div>
              {data.clientes.filter(c=>c.potencia_dbm).length>0?(
                data.clientes.filter(c=>c.potencia_dbm).map(c=>(
                  <div key={c.id} style={S.row}>
                    <span style={S.label}>Puerto {c.puerto} — {c.nombre.split(" ")[0]}</span>
                    <PotenciaVal val={c.potencia_dbm}/>
                  </div>
                ))
              ):<p style={{color:"#6B7280",fontSize:12,margin:0}}>Sin mediciones. El tecnico puede registrar la potencia al editar el cliente.</p>}
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Rango aceptable ONT</div>
              <div style={S.row}><span style={S.label}>Minimo aceptable</span><span style={S.valOk}>-8 dBm</span></div>
              <div style={S.row}><span style={S.label}>Maximo aceptable</span><span style={S.valOk}>-27 dBm</span></div>
              <div style={S.divider}/>
              <div style={S.row}><span style={S.label}>Estimado cliente</span><PotenciaVal val={data.potencia_cliente}/></div>
            </div>
          </>}

          {tab==="notas"&&<>
            <div style={S.card}>
              <div style={S.cardTitle}>Notas tecnicas de campo</div>
              <textarea style={S.textarea} value={notas} onChange={e=>setNotas(e.target.value)} placeholder="Observaciones del campo: estado conectores, mediciones, condiciones del poste..." rows={8}/>
              <button onClick={saveNotas} disabled={saving} style={{...S.btnSave,marginTop:10,width:"100%",padding:"10px 0"}}>{saving?"Guardando...":"Guardar notas"}</button>
            </div>
            <div style={S.card}>
              <div style={S.cardTitle}>Foto del poste</div>
              {nap.foto?<img src={nap.foto} alt="foto poste" style={{width:"100%",borderRadius:8}}/>:<p style={{color:"#6B7280",fontSize:12,margin:0}}>Sin foto registrada</p>}
            </div>
          </>}

        </div>
      )}
    </div>
  );
}
